import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/system';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import { StyledTypographyColorSectionNavLinkMainMedium } from 'components/StyledTypographyColorSectionNavLinkMainMedium';

const BoxOuter = styled(Box, {
  shouldForwardProp: muiPropForwarding('formattedSuggestion')
})(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  cursor: 'pointer'
}));

const BoxInner = styled(Box, {
  shouldForwardProp: muiPropForwarding('isLast')
})(({ theme, isLast }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  borderBottom: isLast ? '' : '1px solid',
  '&:hover *': {
    color: theme.palette.secondary.main
  }
}));

function Suggestion({
  description,
  isLast,
  dataTestId,
  placeId,
  active,
  matchedSubstrings,
  ...rest
}) {
  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };
  return (
    <BoxOuter
      {...rest}
      component={ListItem}
      width="100%"
      data-testid={dataTestId}
    >
      <BoxInner
        color="borders.primary"
        component="span"
        display="block"
        width="100%"
        isLast={isLast}
      >
        <StyledTypographyColorSectionNavLinkMainMedium
          {...styles}
          component="p"
        >
          {description}
        </StyledTypographyColorSectionNavLinkMainMedium>
      </BoxInner>
    </BoxOuter>
  );
}

Suggestion.defaultProps = {
  isLast: false,
  dataTestId: 'autocomplete-suggestion'
};

Suggestion.propTypes = {
  description: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  placeId: PropTypes.any,
  active: PropTypes.any,
  matchedSubstrings: PropTypes.any,
  isLast: PropTypes.bool
};

export default Suggestion;
